import * as React from 'react';
import { createActivityAndActionPlan, getActionPlanList } from '../../api/actionPlanClientApi';
import { Navigate } from 'react-router-dom';
import { ActionPlanListView } from '../../amorg-common/DTOs/ActionPlanListView';
import { rng } from '../../amorg-common';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { PageHeader } from '../../designSystem/PageHeader';
import { Button } from '../../designSystem/button/Button';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { ActionPlanListingPageSectionTable } from '../_components/activities/ActionPlanListingPageSectionTable';

type State = {
    activities: ActionPlanListView[],
};

export function ActionPlanListPage (): JSX.Element
{
    const [state, setState] = React.useState<State>({
        activities: []
    });
    const [loading, setLoading] = React.useState(true);
    const [redirectId, setRedirectId] = React.useState('');

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const actionPlans = await getActionPlanList();
            setState({ activities: actionPlans });
            setLoading(false);
        };
        getData();
    }, []);

    async function handleClickNewActionPlan ()
    {
        setLoading(true);

        const now = new Date();
        const tomorrow = new Date(now.getTime() + 1000 * 60 * 60 * 24); // Add one day
        tomorrow.setHours(8, 0, 0, 0);

        const fortnight = new Date(tomorrow.getTime() + 1000 * 60 * 60 * 24 * 14); // Add two weeks
        fortnight.setHours(16, 0, 0, 0);

        const activityId = rng.getRandomId();
        const actionPlanId = rng.getRandomId();

        const createActionPlanResult = await createActivityAndActionPlan(actionPlanId, activityId, { type: 'Independent' }, 'Ny handleplan', tomorrow, fortnight);
        if (!createActionPlanResult.isSuccess)
        {
            console.error('Failed to create action plan:', createActionPlanResult.errorMessage);
        }
        else
        {
            setLoading(false);
            setRedirectId(actionPlanId);
        }
    }

    const now = new Date();
    const current = state.activities.filter(a => a.end > now);
    const past = state.activities.filter(a => a.end <= now);

    return (
        <ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey="actionplans">
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        {redirectId !== '' &&
                            <Navigate to={`/actionplans/${redirectId}`} />
                        }

                        <LoadingPageOverlay loading={loading} />

                        <PageHeader
                            headerText="Handleplaner"
                            headerIcon="construction"
                            headerStyle="secondary-gray"
                            buttons={
                                <Button variant="filled" icon="actions_plus" size={"42px"} emphasize text="Opret ny handleplan" onClick={handleClickNewActionPlan} />
                            }
                        />
                        
                        <ActionPlanListingPageSectionTable 
                            items={current}
                            noContentText="Ingen aktuelle handleplaner"
                            onClick={(actionPlanId) => setRedirectId(actionPlanId)} />
    
                        {past.length > 0 &&
    
                            <>
                                <PageHeader
                                    headerText="Tidligere Handleplaner"
                                    headerStyle="primary-black"
                                />

                                <ActionPlanListingPageSectionTable 
                                    items={past} 
                                    noContentText="Ingen tidligere handleplaner"
                                    onClick={(actionPlanId) => setRedirectId(actionPlanId)} />
                            </>
                        }
                    </>
                }
            />
        </ProtectedPageWrapper>
    );
}
